import { Profile } from './env'
export { Profile }

/**
 * 디바이스 유형
 */
export enum DeviceType {
  ALL = 'ALL',
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
}

/**
 * 서버 유형
 */
export enum ServerType {
  NONE = 'NONE',
  CONNECT = 'CONNECT',
  EXPRESS = 'EXPRESS',
}

/**
 * logging level
 */
export enum LogLevel {
  Fatal = 0,
  Error = 0,
  Warn = 1,
  Log = 2,
  Info = 3,
  Success = 3,
  Debug = 4,
  Trace = 5,
  Silent = -Infinity,
  Verbose = Infinity,
}
